import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { User } from './authentication.model';
import { LocalUtils } from '../restricted/restricted.utils';
import 'rxjs/add/observable/of';

@Injectable()
export class TokenStorage {

  public getAccessToken(): Observable<string> {
    const token: string = <string>LocalUtils.decrypt(localStorage.getItem('token'));
    return Observable.of(token);
  }

  public getUserToken(): Observable<User> {
    const token: any = JSON.parse(<string>LocalUtils.decrypt(localStorage.getItem('user')));
    return Observable.of(token);
  }

  public setAccessToken(token: string): TokenStorage {
    localStorage.setItem('token', LocalUtils.encrypt(token));
    return this;
  }

  public setUserToken(user: any): TokenStorage {
    // if (user.rooms && user.rooms.length > 0) {
    //   user.myRoom = user.rooms[0];
    //   user.myRoom.type = this.setRoomType(user.rooms[0]);
    // } else if (user.shares && user.shares.length > 0) {
    //   user.myRoom = user.shares[0];
    //   user.myRoom.type = this.setRoomType(user.rooms[0]);
    // } else {
    //   user.myRoom = 0;
    // }
    //user.timestamps = LocalUtils.momento();
    if(user.language) {
      localStorage.setItem('language', JSON.stringify(user.language));
    } else {
      localStorage.setItem('language', JSON.stringify('pt-br'))
    }
    localStorage.setItem('user', LocalUtils.encrypt(JSON.stringify(user)));
    return this;
  }

  // setRoomType(room) {
  //   if (room && room.product && room.product.infrastructure && room.product.infrastructure.platform == 1) {
  //     return 'OnVideo';
  //   } else if (room && room.product && room.product.infrastructure && room.product.infrastructure.platform == 2) {
  //     return 'OnWeb';
  //   }
  // }

  public clear() {
    localStorage.removeItem('user');
    localStorage.removeItem('token');
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/token-storage.service.ts